import React, { useEffect, useState } from "react"
import AppleLogo from "../../assets/icons/apple-logo.svg"
import GooglePlayLogo from "../../assets/icons/google-play-logo.svg"
import QR from "../../assets/icons/qrcode.svg"
import DownloadApple from "../../assets/icons/download-apple.svg"
import DownloadGoogle from "../../assets/icons/download-google.svg"
import Close from "../../assets/icons/close-circle.svg"
import { useMediaQuery, useTheme } from "@mui/material"

import * as S from "./download-app-dialog.styles"
import { getDeviceType } from "../../utils/utils"

const DownloadAppDialog = ({ open, handleClose }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const [deviceType, setDeviceType] = useState("")

  useEffect(() => {
    setDeviceType(getDeviceType())
  }, [])
  return (
    <S.CustomDialog open={open} onClose={handleClose}>
      <S.CloseButton onClick={handleClose}>
        <Close />
      </S.CloseButton>
      <S.Wrapper>
        <S.Title>
          Want to be more sustainable and create local impact, but not sure
          where to begin?
        </S.Title>
        <S.Description>
          Download the Copia App and get started today. You’ll be able to donate
          your surplus immediately, and we’ll provide a receipt with each
          donation so you can claim any standard or enhanced tax deductions
          you’ll qualify for.
        </S.Description>
        <S.DownloadContainer>
          <S.ButtonsContainer>
            {!isMobile ? (
              <>
                <S.DownloadButton
                  href="https://apps.apple.com/us/app/copia/id1563996344s"
                  target="_blank"
                >
                  <AppleLogo />
                  <DownloadApple />
                </S.DownloadButton>

                <S.DownloadButton
                  href="https://play.google.com/store/apps/details?id=com.gocopia.app&hl=en_US&gl=US"
                  target="_blank"
                >
                  <GooglePlayLogo />
                  <DownloadGoogle />
                </S.DownloadButton>
              </>
            ) : deviceType === "iPhone" ? (
              <S.DownloadButton
                href="https://apps.apple.com/us/app/copia/id1563996344s"
                target="_blank"
              >
                <AppleLogo />
                <DownloadApple />
              </S.DownloadButton>
            ) : (
              <S.DownloadButton
                href="https://play.google.com/store/apps/details?id=com.gocopia.app&hl=en_US&gl=US"
                target="_blank"
              >
                <GooglePlayLogo />
                <DownloadGoogle />
              </S.DownloadButton>
            )}
          </S.ButtonsContainer>
          {!isMobile && <S.ScanDescription>or SCAN</S.ScanDescription>}
          {!isMobile && (
            <S.QrContainer>
              <QR />
            </S.QrContainer>
          )}
        </S.DownloadContainer>
      </S.Wrapper>
    </S.CustomDialog>
  )
}

export default DownloadAppDialog
